export const NOTIFICATION_LIST_REQUEST = 'NOTIFICATION_LIST_REQUEST';
export const NOTIFICATION_LIST = 'NOTIFICATION_LIST';
export const NOTIFICATION_LIST_FAILURE = 'NOTIFICATION_LIST_FAILURE';
export const NOTIFICATION_READ_REQUEST = 'NOTIFICATION_READ_REQUEST';
export const NOTIFICATION_READ_SUCCESS = 'NOTIFICATION_READ_SUCCESS';
export const NOTIFICATION_READ_FAILURE = 'NOTIFICATION_READ_FAILURE';

export const NOTIFICATION_REMOVE_REQUEST = 'NOTIFICATION_REMOVE_REQUEST';

export const NOTIFICATION_TOKEN_CREATE_REQUEST = 'NOTIFICATION_TOKEN_CREATE_REQUEST';

export const NOTIFICATION_RESPONSE_MESSAGE = 'NOTIFICATION_RESPONSE_MESSAGE';
